import { useState } from "react"
import { X } from "lucide-react"

const UnskippablePopup = () => {
  const [isVisible, setIsVisible] = useState(true)

  return (
  <>
    {isVisible && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
        <div className="relative bg-white rounded-2xl shadow-2xl p-12 h-auto max-w-[90%] text-center">

          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-4 right-4 rounded-full hover:scale-105 hover:cursor-pointer transition-transform text-slate-600 font-medium"
          >
            <X size={30} strokeWidth={1.75} />
          </button>

          <div className="mt-6"> 
            <h2 className="text-2xl font-bold mb-4">Weekly Circular</h2>
            <p className="text-gray-700 mb-6 text-md">
              See our specials and deals!
            </p>
            <button
              onClick={() => {setIsVisible(false); window.open("https://fooduniverse.keyfood.com/store/foodUniverse/en/circular-pdf", "_blank", "noopener,noreferrer")}}
              className="px-6 py-2 mt-10 bg-blue-600/90 hover:bg-blue-900 text-white transition font-bold"
              
            >
              Click Here!
            </button>
          </div>
        </div>
      </div>
    )}
  </>
)
}

export default UnskippablePopup